export const enum CustomerType {
  B2B = 'B2B',
  B2C = 'B2C',
}
